import transformConstants from './transform';

const transformedClientConstants = transformConstants(process.env);

const constants = {
  ...transformedClientConstants,
};

export const { GQL_HOST, METABASE_HOST } = constants;
